/*@flow*/
import gql from 'graphql-tag';

import type { DocumentNode } from 'graphql';
export default (gql(`
  query GetMemberResource($id: ID!, $resourceName: String!, $companyId: ID!) {
    company(id: $companyId) {
      id
      resource(id: $id, resourceName: $resourceName) {
        ... on Tenant {
          __typename
          id
          name
          address
          theGeom
        }
      }
    }
  }
`): DocumentNode);
